export default "__VITE_ASSET__Co$Gn$MH__"